import apiClient from '../client';
import { Customer, NewCustomerInput } from '@shared/types/Customer';

export const customerService = {
  getAllCustomers: async (): Promise<Customer[]> => {
    const response: any = await apiClient.get('/customers');
    return response.data;
  },

  getCustomerById: async (customerId: string): Promise<Customer> => {
    const response: any = await apiClient.get(`/customers/${customerId}`);
    return response.data;
  },

  createCustomer: async (input: NewCustomerInput): Promise<void> => {
    await apiClient.post('/customers', input);
  },
};
